import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid
} from '@mui/material';
import CustomInput from '../CommonComp/CustomInput/CustomInput';
import CustomButton from '../CommonComp/Buttons/CustomButton';
import { createSimilarImagekeyword } from '../../Services/keywordsApis';
import { action, logsMessagesList, modulesNames } from '../../data/logsMessages';
import { adminAddLogs } from '../../Services/commonService';

function AddSimilarImageKeyword({ open, handleOpen, getListing }) {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async (values, { resetForm }) => {
    setLoading(true);

    const payload = {
      visible_keyword_id: Number(values.visible_keyword_id),
      visible_keyword_name: values.visible_keyword_name,
    };

    try {
      const resp = await createSimilarImagekeyword(payload);
      if (resp) {
        const payloadForLogs = {
          action: action?.add,
          module: modulesNames?.keywords,
          description: logsMessagesList?.keyword?.keywordSimilarImageAdd,
        };
        await adminAddLogs(payloadForLogs);

        resetForm({
          values: {
            visible_keyword_name: '',
            visible_keyword_id: '',
          },
        });

        getListing();
        handleOpen(false);
      }
    } catch (error) {
      console.error('Error creating keyword:', error);
    }

    setLoading(false);
  };

  const formik = useFormik({
    initialValues: {
      visible_keyword_name: '',
      visible_keyword_id: '',
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      visible_keyword_name: Yup.string()
        .required('Similar Image keyword name is required.'),
      visible_keyword_id: Yup.number()
        .typeError('Visible keyword ID must be a number')
        .required('Visible keyword ID is required.'),
    }),
    onSubmit: handleConfirm,
  });

  return (
    <Dialog
      maxWidth="sm"
      open={open}
      onClose={() => handleOpen(false)}
      fullWidth
    >
      <DialogTitle variant="h3">Add Similar Image Keyword</DialogTitle>
      <DialogContent>
        <Box
          noValidate
          component="form"
          onSubmit={formik.handleSubmit}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CustomInput
                variant="outlined"
                fullWidth
                name="visible_keyword_name"
                label="Visible Keyword"
                placeholder="Enter Visible Keyword"
                value={formik.values.visible_keyword_name}
                onChange={formik.handleChange}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  classes: {
                    notchedOutline: 'rounded',
                  },
                }}
                error={formik.touched.visible_keyword_name && Boolean(formik.errors.visible_keyword_name)}
                helperText={formik.touched.visible_keyword_name && formik.errors.visible_keyword_name}
              />
            </Grid>

            <Grid item xs={12}>
              <CustomInput
                variant="outlined"
                fullWidth
                name="visible_keyword_id"
                label="Visible Keyword ID"
                placeholder="Enter Visible Keyword ID"
                value={formik.values.visible_keyword_id}
                onChange={formik.handleChange}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  classes: {
                    notchedOutline: 'rounded',
                  },
                }}
                error={formik.touched.visible_keyword_id && Boolean(formik.errors.visible_keyword_id)}
                helperText={formik.touched.visible_keyword_id && formik.errors.visible_keyword_id}
              />
            </Grid>
          </Grid>

          <div style={{ display: 'flex', justifyContent: 'end', marginTop: 15 }}>
            <CustomButton
              color="buttonPrimary"
              type="submit"
              loading={loading}
            >
              Confirm
            </CustomButton>
            <CustomButton
              onClick={() => {
                formik.resetForm({
                  values: {
                    visible_keyword_name: '',
                    visible_keyword_id: '',
                  },
                });
                handleOpen(false);
              }}
              disabled={loading}
            >
              Cancel
            </CustomButton>
          </div>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default AddSimilarImageKeyword;
